
const css = `
/* Based on https://gist.github.com/flqw/5fe75d8c507b382062ae49fcf2f7eb83 */
:host { display: block; height: 40px; }

.spinner {
	position: relative;
	overflow: hidden;
	height: 100%;
	aspect-ratio: 1;
	margin: auto;
}

.spinner:before {
	content: '';
	display: block;
	padding-top: 100%;
}

.spinner svg {
	position: absolute;
	inset: 0;
	transform-origin: center center;
	animation: spinner-rotate 2.42s linear infinite;
	rotate: 270deg;
}

.spinner svg circle {
	animation: spinner-dash 2.42s ease-in-out infinite;
	fill: none;
	stroke: currentColor;
	stroke-linecap: round;
	stroke-width: 3;
}

@keyframes spinner-rotate {
	100% {
		transform: rotate(720deg);
	}
}

@keyframes spinner-dash {
	0% {
		stroke-dasharray: 0, 1000;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 89, 1000;
		stroke-dashoffset: -35;
	}
	100% {
		stroke-dasharray: 89, 1000;
		stroke-dashoffset: -124; /* < 2*pi*20 */
	}
}
`

class Spinner extends HTMLElement {
	connectedCallback() {
		const shadow = this.attachShadow({mode: 'open'})

		const style = shadow.appendChild(document.createElement("style"))
		style.textContent = css

		const spinner = shadow.appendChild(document.createElement('div'))
		spinner.setAttribute('class', 'spinner')

		const svg = spinner.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'))
		svg.setAttribute('viewBox', '-21.5 -21.5 43 43')

		const circle = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'circle'))
		circle.setAttribute('r', '20')
	}
}

customElements.define('x-spinner', Spinner)
